import { PipeTransform, Pipe } from "@angular/core";
import { PromoMultiple } from '../Model/PromoMultiples.Model';

@Pipe({
  name: 'PromoMultipleFilter',
  standalone: false
})
export class PromoMultipleFilterPipe implements PipeTransform {

  transform(promoMultiples: PromoMultiple[], searchTerm: string, field: string): PromoMultiple[] {
    if (!promoMultiples || !searchTerm) return promoMultiples;

    const lowerSearchTerm = searchTerm.toLowerCase();
    const numericSearchTerm = Number(searchTerm);

    return promoMultiples.filter(promo => this.matchesSearchTerm(promo, lowerSearchTerm, numericSearchTerm));
  }

  private matchesSearchTerm(promo: PromoMultiple, term: string, numTerm: number): boolean {
    const labelMatch = promo.label?.toLowerCase().includes(term);
    const minMatch = promo.min?.includes(numTerm);
    const maxMatch = promo.max?.includes(numTerm);

    return !!(labelMatch || minMatch || maxMatch);
  }
}
